<template>
  <div v-if="orderDetailBonuses.data.length" class="space-y-2">
    <div class="flex items-center justify-between">
      <dt class="text-xs text-gray-700">{{ type === 'follow-up' ? 'Free Susulan' : 'Free' }}</dt>
      <BaseInput size="sm" type="text" placeholder="Cari barang" :shadow="false" debounce v-model="filter.search" @native-input="loadOrderDetailBonuses" />
    </div>
    <Datatable
      :scroll-x="false"
      :total="orderDetailBonuses.meta.page.total"
      :perPage="orderDetailBonuses.meta.page.perPage"
      :currentPage="orderDetailBonuses.meta.page.currentPage"
      compact
      @pagechanged="onChangePage"
      :columns="
        [
          { id: 'code', name: 'Kode Barang' },
          { id: 'name', name: 'Nama Barang' },
          !columns.includes('!qty')
            ? { id: 'qty', name: 'Jumlah', theadClass: 'text-right' }
            : null,
          columns.includes('free_follow_up_qty')
            ? {
                id: 'free_follow_up_qty',
                name: 'Susulan',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('regular_stock_qty')
            ? {
                id: 'regular_stock_qty',
                name: 'Reimbursement',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('packed_qty')
            ? {
                id: 'packed_qty',
                name: 'Dikirim',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('unpacked_qty')
            ? {
                id: 'unpacked_qty',
                name: 'Belum Dikirim',
                theadClass: 'text-right',
              }
            : null,
        ].filter((item) => !!item)
      "
    >
      <template #tbody="{ classes }">
        <tr
          v-for="(orderDetailBonus, index) in orderDetailBonuses.data"
          :key="index"
          :class="classes.tr"
        >
          <td :class="[classes.td]">
            <p class="font-bold text-gray-900">
              {{ orderDetailBonus.attributes.product_code }}
            </p>
          </td>
          <td :class="[classes.td]">
            {{ orderDetailBonus.attributes.product_name }}
          </td>
          <td v-if="!columns.includes('!qty')" :class="[classes.td, 'text-right']">
            {{ getQty(orderDetailBonus) }}
          </td>
          <td
            v-if="columns.includes('free_follow_up_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{ checkReimbursementQtyVisible(orderDetailBonus) ? (orderDetailBonus.attributes.free_follow_up_remaining_qty) : 0 }}
          </td>
          <td
            v-if="columns.includes('regular_stock_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{ checkReimbursementQtyVisible(orderDetailBonus) ? (orderDetailBonus.attributes.reimbursement_remaining_qty) : 0 }}
          </td>
          <td
            v-if="columns.includes('packed_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{ orderDetailBonus.attributes.bonus_shipped_qty }}
          </td>
          <td
            v-if="columns.includes('unpacked_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{
              (orderDetailBonus.attributes.bonus_qty -
                orderDetailBonus.attributes.bonus_shipped_qty)
               
            }}
          </td>
        </tr>
      </template>
    </Datatable>
  </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    orderId: String,
    type: {
      type: String,
      default: 'order'
    },
    columns: {
      type: Array,
      default: () => []
    },
    preview: Object
  },
  emits: ['update-loading', 'load'],
  data() {
    return {
      filter: {
        search: null
      },
      loading: false,
      orderDetailBonuses: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    typeFilter() {
      if (this.type === 'order') {
        return {}
      }

      if (this.type === 'follow-up') {
        return { 'filter[completed]': false }
      }

      if (this.type === 'free_reimbursement') {
        return { 'filter[free_reimbursement_completed]': false }
      }

      return { 'filter[reimbursement_completed]': false }
    }
  },
  methods: {
    getQty(orderDetailBonus) {
      if (this.type === 'free_reimbursement') {
        return orderDetailBonus.attributes.free_follow_up_remaining_qty
      }

      if (this.type === 'reimbursement') {
        return orderDetailBonus.attributes.reimbursement_remaining_qty
      }

      if (this.type === 'follow-up') {
        return orderDetailBonus.attributes.bonus_qty - orderDetailBonus.attributes.bonus_shipped_qty
      }
      
      return orderDetailBonus.attributes.bonus_qty
    },
    checkReimbursementQtyVisible(orderDetailBonus) {
      return ![
        'Draft',
        'Diproses Kasir',
        'Diproses Gudang Pengeluaran',
        'Persiapan'
      ].includes(orderDetailBonus.attributes.order_status)
    },
    async loadOrderDetailBonuses(params) {
      if (this.preview) {
        this.orderDetailBonuses = this.preview
      } else {
        this.$emit('update-loading', true);

        const [res, err] = await this.request(
          `/api/v1/orders/${this.orderId}/order-detail-bonuses`,
          {
            params: {
              'page[size]': 5,
              'fields[order-detail-bonuses]]':
                'product_code,product_name,bonus_qty,reimbursement_remaining_qty,free_follow_up_remaining_qty,bonus_shipped_qty,free_follow_up_qty,regular_stock_qty,order_status',
              'filter[search]': this.filter.search,
              ...this.typeFilter,
              ...params
            },
          }
        );

        if (!err) {
          this.orderDetailBonuses = res;
        }

        this.$emit('update-loading', false);
      }
    },
    onChangePage(page) {
      this.loadOrderDetailBonuses({
        'page[number]': page
      })
    }
  },
  async created() {
    await this.loadOrderDetailBonuses();

    this.$emit('load', { hasItems: this.orderDetailBonuses.data.length })
  },
};
</script>
